import { t } from 'i18next';

export const DEPARTMENT_FORM = {
  CREATE: 'Create a new Department',
  edit: text => `${t('Edit')} ${text}`,
};
